function convertSecondsToMinutes(seconds) {
    if (typeof seconds !== 'number' || seconds < 0) {
        return '00:00';
    }

    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);

    const m = mins.toString().padStart(2, '0');
    const s = secs.toString().padStart(2, '0');

    return `${m}:${s}`;
}

export { convertSecondsToMinutes };
